import React, { useState, useEffect } from "react";
import { connect } from "react-redux";

import AppLayoutWrapFull from "components/AppLayoutWrapFull";
import Container from "components/Container/Container";
import PageHeader from "components/PageHeader/PageHeader";
import PageHeaderActions from "components/PageHeader/components/PageHeaderActions/PageHeaderActions";
import FullDataTable from "components/DataTable/FullDataTable";
import TableDefAudits from "table-defs/TableDefAudits";
import AddAuditModal from "./components/AddAuditModal/AddAuditModal";
import { withRouter, useHistory } from "react-router-dom";
import { loadAuditsAction, deleteAuditAction, loadSitesAction, updateAuditAction, reopenAuditAction, notifyAuditAction, loadActsAction } from "store/actions/Actions";
import useFilterRows from "helpers/customHooks/useFilterRows";

import { setSelectedRows, toggleDropdowns } from "helpers/utils";

const Audits = props => {
    const history = useHistory();

    const { loadSitesAction, loadAuditsAction, loadActsAction, SitesReducer, AuditsReducer, ActsReducer, UserOrgSiteReducer } = props;
    const [showModal, setShowModal] = useState(false);

    useEffect(() => {
        if (!SitesReducer.sites) {
            loadSitesAction();
        }
    }, [SitesReducer.sites, loadSitesAction]);

    useEffect(() => {
        if (!ActsReducer.acts) {
            loadActsAction();
        }
    }, [ActsReducer.acts, loadActsAction]);

    useEffect(() => {
        if (!AuditsReducer.audits && SitesReducer.sites && ActsReducer.acts) {
            loadAuditsAction();
        }
    }, [AuditsReducer.audits, SitesReducer.sites, ActsReducer.acts, loadAuditsAction]);

    // ##############################################

    const noFilters = {
        text: "",
        type: "",
        "last-action": "",
        status: "",
        role: "",
        site: "",
        start: "",
        end: "",
        selected_sites: [],
        dateField: "assigned"
    };

    const [filters, setFilters] = useState(noFilters);

    const setFilter = filterName => e => {
        setFilters({
            ...filters,
            [filterName]: e.target.type === "checkbox" ? e.target.checked : e.target.value || ((e.target && e.target.attributes && e.target.attributes.value && e.target.attributes.value.value) || '')
        });
    };

    const setDateFilter = filterName => value => {
        setFilters({
            ...filters,
            [filterName]: value
        });
    };

    const filteredRows = useFilterRows(filters, AuditsReducer.audits);

    const actDropdownRef = React.createRef();
    const siteDropdownRef = React.createRef();
    const chooseActionDropdownRef = React.createRef();
    const statusDropdownRef = React.createRef();

    const [selectedAuditIds, setSelectedAuditIds] = useState([]);
    const selectedIds = selectedAuditIds.map(item => item.id);
    const is_super = (UserOrgSiteReducer.selected && UserOrgSiteReducer.selected.is_super) || false;

    return (
        <AppLayoutWrapFull
            onClick={toggleDropdowns([
                actDropdownRef,
                siteDropdownRef,
                chooseActionDropdownRef,
                statusDropdownRef
            ])}
        >
            <PageHeader showStats={true}>
                <PageHeaderActions
                    primaryButtonText="ADD AUDIT"
                    primaryButtonHandler={() => setShowModal(!showModal)}
                    searchHandler={e => setFilters({ ...filters, text: e.target.value || "" })}
                    searchValue={filters.text}
                    chooseAction={[
                        {
                            actionName: "Notify Selected",
                            actionHandler: () => props.notifyAuditAction({ items: selectedIds })
                        },
                        {
                            actionName: "Delete Selected",
                            actionHandler: () => props.deleteAuditAction({ items: selectedIds })
                        }
                    ]}
                    chooseActionDropdownRef={chooseActionDropdownRef}
                    site={{
                        onClick: (e) => {
                            if (e.target.type === 'checkbox') {
                                let selected_sites = filters.selected_sites.slice();
                                if (e.target.checked) {
                                    selected_sites.push(e.target.value);
                                } else {
                                    selected_sites = selected_sites.filter(site => site !== e.target.value);
                                }
                                setFilters({
                                    ...filters,
                                    site: selected_sites.length > 0 ? `Sites (${selected_sites.length})` : 'Site',
                                    // site: "Site",
                                    selected_sites: selected_sites
                                });
                            }
                        },
                        sites: SitesReducer.sites ? SitesReducer.sites.map(site => {
                            return {
                                id: site.id,
                                siteName: site.name,
                                value: filters.selected_sites.includes(site.id) ? true : false
                            }
                        }) : [],
                    }}
                    siteDropdownRef={siteDropdownRef}
                    status={{
                        onChange: setFilter("status"),
                        options: ["All", "Finalized", "Not Finalized", "Ongoing"]
                    }}
                    statusDropdownRef={statusDropdownRef}
                    dateRange={{
                        onChangeStart: setDateFilter("start"),
                        onChangeEnd: setDateFilter("end")
                    }}
                    filters={filters}
                    resetFilters={() => {
                        setFilters(noFilters);
                    }}
                />
            </PageHeader>
            <Container wide fluid>
                {AuditsReducer.audits &&
                <FullDataTable
                    rowsData={filteredRows}
                    definitions={TableDefAudits}
                    onRowClick={function(e) {
                        const auditPath = this.props.rowData.act === "6" ? 'audit-device' : 'audit';
                        if (
                            e.currentTarget.classList.contains("col-actions") ||
                            e.currentTarget.classList.contains("col-row-selector")
                        )
                            return;
                            history.push(`/achieve/audits/${auditPath}?id=${this.props.rowData.id}`);
                    }}
                    setSelectedRows={setSelectedRows(["id"], setSelectedAuditIds)}
                    customTableProps={{
                        // selectedRows: state.selectedRows,
                        view: (rowData) => {
                            history.push(`/achieve/audits/${rowData.act === "6" ? 'audit-device' : 'audit'}?id=${rowData.id}`);
                        },
                        delete: ({ id }) => {
                            props.deleteAuditAction({items: [id]});
                        },
                        reopen: ({ id }) => {
                            props.reopenAuditAction({ id });
                        },
                        is_super: is_super,
                    }}
                />
                }
            </Container>
            {showModal ? (
                <AddAuditModal
                    setShowModal={setShowModal}
                    actDropdownRef={actDropdownRef}
                    siteDropdownRef={siteDropdownRef}
                />
            ) : null}
        </AppLayoutWrapFull>
    );
};

const mapStateToProps = (state) => ({
    AuditsReducer: state.AuditsReducer,
    ActsReducer: state.ActsReducer,
    SitesReducer: state.SitesReducer,
    UserOrgSiteReducer: state.UserOrgSiteReducer,
});

const mapDispatchToProps = {
    loadSitesAction,
    loadAuditsAction,
    loadActsAction,
    deleteAuditAction,
    updateAuditAction,
    reopenAuditAction,
    notifyAuditAction
};

export default withRouter(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(Audits)
);
